import React, { Component } from 'react';
import { Checkbox, DatePicker } from '@cimpress/react-components';

export default class DatePickerDemo extends Component {
  state = {
    dateValue1: '',
    dateValue2: '2020-10-25',
    dateValue3: '2010-01-25',
    input: true,
  };

  onChangeShowAsInput = () => {
    const previousShowInput = this.state.input;
    this.setState({ input: !previousShowInput });
  };

  render() {
    const { input } = this.state;

    return (
      <>
        <div className="row">
          <div className="col-xs-4">
            Uncontrolled
            <DatePicker placeholder="Select a date" onChange={d => this.setState({ dateValue1: d })} />
            Selected: {this.state.dateValue1 ? this.state.dateValue1.toISOString() : 'n/a'}
            <br />
            <br />
          </div>
          <div className="col-xs-4">
            Controlled
            <DatePicker
              placeholder="Select a date"
              value={this.state.dateValue2}
              onChange={d => {
                this.setState({ dateValue2: d });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-4">
            With label, help text & clearable
            <DatePicker
              label="Select a date"
              dateFormat="Y-MM-DD"
              helpText="Very important help text below"
              value={this.state.dateValue3}
              closeOnClickOutside={true}
              closeOnSelect={true}
              isClearable={true}
              onChange={d => {
                this.setState({ dateValue3: d });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-4">
            <Checkbox
              checked={input}
              label="Display the picker with an input field"
              onChange={this.onChangeShowAsInput}
            />
            <DatePicker input={input} placeholder="Select a date" />
          </div>
        </div>
      </>
    );
  }
}
